<template>
    <div class="vuemenu navigation">
        <slot></slot>
    </div>
</template>
<script>
export default {
    computed: {
        $collapseItems() {
            return this.$children.filter(child => child._isCollapseItem)
        }
    },
    methods: {
        openByIndex(index, subindex) {
            this.$collapseItems.forEach((item, i) => {
                if (i !== index) {
                    item.isActived = false
                }
                if (item.$collapseItems.length) {
                    item.$collapseItems.forEach((sitem, j) => {
                        if (j !== subindex) {
                            sitem.isActived = false
                        }
                    });
                }
            })
        }
    },
    mounted() {
        this.$on("closeall", (index, subindex) => {
            this.openByIndex(index, subindex);
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/left-side/default/menu/vueMenu.vue